import { render, staticRenderFns } from "./living-arrangements-form.vue?vue&type=template&id=2c7b76ce&scoped=true"
import script from "./living-arrangements-form.vue?vue&type=script&lang=js"
export * from "./living-arrangements-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7b76ce",
  null
  
)

export default component.exports